// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nk-c";
export var backButton = "_nk-4";
export var backIcon = "_nk-5";
export var chevronShortcut = "_nk-6";
export var container = "_nk-1";
export var editor = "_nk-8";
export var editorWrapper = "_nk-7";
export var prefix = "_nk-2";
export var searchIcon = "_nk-3";
export var suffix = "_nk-9";
export var suffixContent = "_nk-a";
export var suffixText = "_nk-b";
export var wrapper = "_nk-0";